module.exports = __webpack_public_path__ + "img/2024-11-15d_3.40de36eb.jpg";